import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  getGeoLocation,
  getDeliveryPickup,
  getDeliveryInfo,
  getPickupInfo
} from '~/selectors';

export default function useSendDeliveryPickup(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const { isLoaded } = useSelector(getDeliveryPickup);
  const delivery = useSelector(getDeliveryInfo);
  const pickup = useSelector(getPickupInfo);
  const { zip } = useSelector(getGeoLocation);

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!isLoaded) return;
    trackEvent('Delivery and Pickup', {
      delivery,
      pickup,
      zip: zipRef.current
    });
  }, [delivery, isLoaded, pickup, trackEvent]);
}
